$(document).ready(function () {

    $(document).on("click", ".accordion-item-title", function () {
        var $this = $(this);
        var $accordionItem = $this.parent();
        var $body = $this.next(".accordion-item-body");
        var isOpen = $accordionItem.hasClass("open");
        $accordionItem.toggleClass("open", !isOpen);
        $body.stop(true, true).slideToggle(200);
        var $iconClosed = $this.find(".icon-closed");
        var $iconOpen = $this.find(".icon-open");
        if (isOpen) {
            $iconClosed.css("opacity", 1);
            $iconOpen.css("opacity", 0);
        }
        else {
            $iconClosed.css("opacity", 0);
            $iconOpen.css("opacity", 1);
        }
    });

});
